var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBreasts1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 59,
  fill: "none",
  viewBox: "0 0 23 59"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1.25 1c1.58 3.518 4.122 7.556 7.423 12.194C13.286 19.67 20.9 23.258 21.85 29.804c1.291 8.886-6.142 12.434-6.142 12.434s-.35 4.038-.4 5.897c-.08 3.269.05 6.217-.14 9.865"
})));
export default SvgBreasts1;